var React = require('react');

function ListOutline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"none","d":"M160 144h288M160 256h288M160 368h288","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","key":0}),React.createElement("circle",{"cx":"80","cy":"144","r":"16","fill":"currentColor","key":1}),React.createElement("circle",{"cx":"80","cy":"256","r":"16","fill":"currentColor","key":2}),React.createElement("circle",{"cx":"80","cy":"368","r":"16","fill":"currentColor","key":3})]);
}

ListOutline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 512 512"};

module.exports = ListOutline;

ListOutline.default = ListOutline;
